import axios from 'axios';
import eventEmitter from '~/utils/events/event-emitter';

// set up global axios interceptors for error handling
axios.interceptors.response.use(
  response => response, // Pass through successful responses
  error => {
    // Handle errors globally
    console.log('interceptors', { error });
    if (error.response) {
      // Server responded with a status code outside 2xx
      if (error.response.status === 401) {
        // Handle unauthorized globally
      }
      // You can add more status checks here
    } else if (error.request) {
      // No response received
    } else {
      // Something else happened
    }
    // Optionally, re-throw the error so individual requests can also handle it
    return Promise.reject(error);
  }
)

const headers = {
  'Content-Type': 'application/json', // we're sending
  'Accept': 'application/json' // we're expecting
};

// should be able to combine these somehow
export const appAxios = axios.create({
  headers,
});

export const api = axios.create({
  baseURL: '/api',
  headers,
});


// set token for axios headers
export const setApiCsrfToken = (csrfToken: string | null) => {
  api.defaults.headers['X-CSRF-Token'] = csrfToken;
  appAxios.defaults.headers['X-CSRF-Token'] = csrfToken;
}

// never unsubscribes, not a component
eventEmitter.on('csrfTokenChanged', setApiCsrfToken)